import { Link } from "react-router-dom";
import StarField from "@/components/StarField";
import TopBar from "@/components/TopBar";
import { motion } from "framer-motion";

export default function LegalLayout({ eyebrow, title, updated, children, testid }) {
  return (
    <div className="relative min-h-screen overflow-hidden" data-testid={testid}>
      <StarField count={120} />
      <TopBar />

      <main className="relative z-20 mx-auto max-w-3xl px-6 pt-8 pb-32">
        <motion.div
          initial={{ opacity: 0, y: 14 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="border-l border-cyan-400/40 pl-6 mb-14"
        >
          <div className="font-mono text-[10px] tracking-[0.4em] uppercase text-cyan-400/80 mb-4">
            — {eyebrow} —
          </div>
          <h1
            className="font-display text-4xl sm:text-5xl lg:text-6xl font-black tracking-tight text-white leading-[0.95]"
            data-testid="legal-title"
          >
            {title}
          </h1>
          <div className="font-mono text-xs uppercase tracking-[0.3em] text-white/40 mt-6">
            Last updated · {updated}
          </div>
        </motion.div>

        <motion.article
          initial={{ opacity: 0 }}
          animate={{ opacity: 1 }}
          transition={{ delay: 0.2, duration: 0.8 }}
          className="legal-prose space-y-8 text-white/75 leading-relaxed"
        >
          {children}
        </motion.article>

        <div className="mt-24 pt-10 border-t border-white/10 flex flex-wrap gap-6 justify-between items-center">
          <Link
            to="/"
            className="font-mono text-[11px] tracking-[0.3em] uppercase text-cyan-400 hover:text-white transition"
            data-testid="legal-back-home"
          >
            ← Return to the vault
          </Link>
          <div className="flex gap-6 font-mono text-[10px] tracking-[0.3em] uppercase text-white/40">
            <Link to="/terms" className="hover:text-cyan-400 transition">Terms</Link>
            <Link to="/privacy" className="hover:text-cyan-400 transition">Privacy</Link>
            <Link to="/refund" className="hover:text-cyan-400 transition">Refunds</Link>
          </div>
        </div>
      </main>
    </div>
  );
}
